'use strict';

var _rollupPluginBabelHelpers = require('../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var PropTypes = require('prop-types');
var reactTransitionGroup = require('react-transition-group');
var fixed = require('./fixed.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var SnackBar = /*#__PURE__*/function (_React$PureComponent) {
  _rollupPluginBabelHelpers.inherits(SnackBar, _React$PureComponent);

  var _super = _rollupPluginBabelHelpers.createSuper(SnackBar);

  function SnackBar() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, SnackBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "state", {
      visible: true
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "handleDismiss", function () {
      window.clearTimeout(_this.timer);

      _this.setState({
        visible: false
      });

      _this.props.onDismiss();
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(SnackBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var hideTimeout = this.props.hideTimeout;

      if (hideTimeout) {
        if (this.timer) window.clearTimeout(this.timer);
        this.timer = window.setTimeout(this.handleDismiss, hideTimeout);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.timer) window.clearTimeout(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var className = "".concat(this.props.className, " dynamic");

      var fixedProps = _rollupPluginBabelHelpers.objectSpread2({}, this.props, {
        className: className,
        onDismiss: this.handleDismiss
      });

      return /*#__PURE__*/React__default['default'].createElement(reactTransitionGroup.CSSTransition, {
        appear: true,
        classNames: "transition",
        "in": this.state.visible,
        timeout: {
          enter: 500,
          exit: 700
        },
        unmountOnExit: true
      }, /*#__PURE__*/React__default['default'].createElement(fixed, fixedProps));
    }
  }]);

  return SnackBar;
}(React__default['default'].PureComponent);

_rollupPluginBabelHelpers.defineProperty(SnackBar, "propTypes", {
  className: PropTypes__default['default'].string,
  hideTimeout: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].bool]),
  error: PropTypes__default['default'].bool,
  title: PropTypes__default['default'].string.isRequired,
  children: PropTypes__default['default'].node.isRequired,
  onDismiss: PropTypes__default['default'].func
});

_rollupPluginBabelHelpers.defineProperty(SnackBar, "defaultProps", {
  className: '',
  hideTimeout: 4000,
  error: false,
  onDismiss: function onDismiss() {}
});
SnackBar.Fixed = fixed;

module.exports = SnackBar;
